export default __webpack_public_path__ + "images/JB.53b5aab.png";